import { array, boolean, number, object, string } from 'yup'
import { ServiceAvailability } from './advisories.types'

// A localized message map, e.g. { en: '...', fr: '...' }. Allow arbitrary locale keys.
const LocalizedMessageSchema = object().test(
  'is-localized-message',
  'advisory message must be a map of locale strings',
  (value) =>
    value == null ||
    (typeof value === 'object' &&
      Object.values(value).every((v) => typeof v === 'string'))
)

export const DrrRestrictionSchema = object().shape({
  enabled: boolean().required(),
  advisoryMessages: array().of(LocalizedMessageSchema),
  restrictionType: string(),
})

export const TowLimitRestrictionSchema = object().shape({
  enabled: boolean().required(),
  advisoryMessages: array().of(LocalizedMessageSchema),
  restrictionId: string(),
  restrictionType: string(),
  maxMiles: number(),
})

export const ServiceAvailabilitySchema = object<ServiceAvailability>().shape({
  drr: DrrRestrictionSchema.optional().default(undefined),
  towLimit: TowLimitRestrictionSchema.optional().default(undefined),
})
